import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

// Translations for FEDYK Furniture - EN, NL, RO, RU
export const translations = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About',
      b2c: 'Shop',
      b2b: 'Trade',
      projects: 'Projects',
      blog: 'Journal',
      contact: 'Contact',
    },
    categories: {
      kitchens: 'Kitchens',
      wardrobes: 'Wardrobes',
      doors: 'Doors',
      wall_panels: 'Wall Panels',
      soft_furniture: 'Soft Furniture',
      ready_solutions: 'Ready Solutions',
      custom_furniture: 'Custom Furniture',
    },
    doorSubcategories: {
      invisible_doors: 'Invisible Doors',
      sliding_partitions: 'Sliding Partitions',
      pivot_doors: 'Pivot Doors',
    },
    common: {
      viewAll: 'View All',
      learnMore: 'Learn More',
      requestQuote: 'Request Quote',
      addToWishlist: 'Add to Wishlist',
      removeFromWishlist: 'Remove from Wishlist',
      addToQuote: 'Add to Quote',
      viewDetails: 'View Details',
      backTo: 'Back to',
      search: 'Search products...',
      filter: 'Filter',
      sort: 'Sort',
      price: 'Price',
      material: 'Material',
      finish: 'Finish',
      category: 'Category',
      subcategory: 'Subcategory',
      loading: 'Loading...',
      noResults: 'No results found',
      subscribe: 'Subscribe',
      send: 'Send',
      submit: 'Submit',
      required: 'Required',
      optional: 'Optional',
      uploadPhoto: 'Upload Photo',
      budget: 'Budget',
      buildingType: 'Building Type',
      newBuild: 'New Build',
      under10Years: 'Under 10 Years',
      over10Years: 'Over 10 Years',
      wishesComments: 'Wishes and Comments',
      featured: 'Featured',
      name: 'Name',
      sortBy: 'Sort by',
      elegance: 'Elegance',
      accept: 'Accept',
      cancel: 'Cancel',
      ok: 'OK',
      backToProjects: 'Back to Projects',
      exploreProducts: 'Explore Products',
      ourCollections: 'Our Collections',
      getInTouch: 'Get in Touch',
      clearFilters: 'Clear All Filters',
      specifications: 'Specifications',
      dimensions: 'Dimensions',
      width: 'Width',
      depth: 'Depth',
      height: 'Height',
      weight: 'Weight',
    },
    hero: {
      title: 'ONE SPACE CONCEPT',
      subtitle: 'A comprehensive approach to interior design, where aesthetics, comfort, and advanced functionality are seamlessly integrated.',
      cta: 'Discover the Concept',
    },
    about: {
      title: 'About FEDYK Furniture',
      subtitle: 'Where architecture meets interior design',
      description: 'FEDYK Furniture represents the pinnacle of European craftsmanship, offering bespoke interior solutions for discerning clients worldwide.',
    },
    b2b: {
      title: 'Trade Program',
      subtitle: 'Exclusive benefits designed for architects, interior designers, developers, and dealers.',
      architects: 'Architects',
      designers: 'Interior Designers',
      developers: 'Developers',
      dealers: 'Dealers',
      register: 'Register for Trade',
      login: 'Trade Login',
      downloadCenter: 'Download Center',
      tradePricing: 'Trade Pricing Matrix',
      projectSupport: 'Project Support',
      architectsDesc: 'Licensed architecture practices',
      designersDesc: 'Professional interior design studios',
      developersDesc: 'Property development companies',
      dealersDesc: 'Authorized retail partners',
      eligibilityTitle: 'Who Can Apply?',
      eligibilityEyebrow: 'Eligibility',
      readyTitle: 'Ready to Get Started?',
      readySub: 'Apply for our trade program today and unlock exclusive benefits for your projects.',
      readyBtn: 'Apply Now',
      catalogEyebrow: 'Trade Resources',
      catalogDescFallback: 'Our complete annual portfolio — every collection, every system, every finish. Bound in a single, beautifully crafted PDF for architects, interior designers, and trade partners.',
      catalogBullet1: 'Full catalogue · 180+ pages',
      catalogBullet2: 'Technical drawings & material library',
      catalogBullet3: 'Reserved for approved trade accounts',
      advantage_1_desc: 'CAD files, BIM models, 3D assets and technical specifications.',
      advantage_2_desc: 'Pricing is tailored per project brief. Submit your blueprint — response within 24h.',
      advantage_3_desc: 'Direct line to our concierge. Material questions, lead-times, specs.',
      advantage_4_title: 'Project Collaboration',
      advantage_4_desc: 'Co-design custom furniture with our studio. Submit a project brief.',
      cta_open_library: 'Open Library →',
      cta_signin_required: 'Sign in required',
      cta_request_quote: 'Request Quote →',
      cta_talk_concierge: 'Talk to Concierge →',
      cta_submit_brief: 'Submit Brief →',
      cta: 'Join Trade Program / Contact Us',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      offices: 'Our Offices',
      primaryOffice: 'Main Office',
      successMsg: 'Message sent! We will get back to you soon.'
    },
    customFurniture: {
      title: 'Custom Furniture Brief',
      subtitle: 'Tell us about your project',
      whatFurniture: 'What furniture or product do you want?',
      roomDimensions: 'Room/space dimensions',
      attachPhotos: 'Attach reference photos',
      attachRoomPhotos: 'Attach room photos',
      submitBrief: 'Submit Brief',
      successMessage: 'Your brief has been submitted. We will contact you soon.',
    },
    cart: {
      title: 'Quote Request',
      empty: 'Your cart is empty',
      checkout: 'Request Quote',
      total: 'Total',
      yourDetails: 'Your Details',
      successMessage: 'Your request has been received. A manager will contact you to provide an invoice.',
    },
    newsletter: {
      title: 'Stay Informed',
      subtitle: 'Subscribe to receive updates on new collections and exclusive offers.',
      placeholder: 'Enter your email',
      success: 'Thank you for subscribing!',
    },
    footer: {
      tagline: 'Architectural elegance for modern interiors',
      quickLinks: 'Quick Links',
      support: 'Support',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.',
    },
    auth: {
      login: 'Sign In',
      register: 'Register',
      logout: 'Sign Out',
      email: 'Email',
      password: 'Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      b2bRegister: 'Register as Trade Professional',
      iAmProfessional: 'I am a design professional (architect, designer, contractor, retailer)',
      companyName: 'Company Name',
      portfolioLink: 'Portfolio / Instagram link',
      portfolioHint: 'Helps us verify your studio faster.',
      vatNumber: 'VAT Number (optional)',
      profession: 'Professional Role',
      architect: 'Architect',
      interiorDesigner: 'Interior Designer',
      contractor: 'Contractor',
      retailer: 'Retailer',
      b2bSubmitted: 'Application Submitted!',
      pendingApprovalTitle: 'Application Under Review',
      pendingApprovalText: 'Your trade professional account request is being processed by our atelier team. Notifications will follow via email.',
      accessDenied: 'Access Denied',
      accessDeniedText: 'An approved trade professional account is required to access this environment.',
      loginSubtitle: 'Enter your credentials to access the trade portal',
      registerSubtitle: 'Create an account to initialize registration',
      signingIn: 'Signing in...',
      registering: 'Creating account...',
      areYouPro: 'Are you a design professional?',
      professionalAddress: 'Professional Address',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal Code',
      streetAddress: 'Street & Number',
      welcomeBack: 'Welcome back!',
      loginFailed: 'Authentication failed',
      registrationSuccess: 'Registration successful! Please check your email to verify your account.',
      registrationFailed: 'Registration failed',
    },
    chat: {
      title: 'FEDYK Furniture Support',
      subtitle: 'Ask us anything',
      placeholder: 'Type a message...',
      send: 'Send',
      connectWhatsApp: 'Continue on WhatsApp',
      connectTelegram: 'Continue on Telegram',
      requestHuman: 'Speak with a person',
      humanConnecting: 'Connecting you with a representative...',
      humanRequested: 'A manager will join shortly...',
      greeting: 'Hello! How can I help you today? I can answer questions about our products, services, and pricing.',
      nameAsk: 'What is your name?',
      namePlaceholder: 'Your name',
      contactPlaceholder: 'Phone or Email (optional)',
      start: 'Start Chat',
      call: 'Call us',
      whatsapp: 'WhatsApp',
      proactive: 'Looking for inspiration? Our architect can prepare a concept for your space.'
    },
    lookbook: {
      lookbook: 'Lookbook',
      description: 'A curated selection of bespoke pieces. Each design begins with a conversation — request a concept tailored to your space.',
      requestConcept: 'Request Concept',
      consultArchitect: 'Consult an Architect',
      inConcept: 'In Concept Request',
      eyebrow: 'Collections',
      empty: 'No pieces match your filters.',
      reset: 'Reset Filters',
      wishlistTitle: 'Wishlist',
      wishlistEyebrow: 'Saved Items'
    },
    leadCapture: {
      step1Title: 'What interests you?',
      step1Sub: 'Choose a collection and we will connect you with our architect',
      step2Title: 'Your contact details',
      step2Sub: 'We will redirect you to our private Telegram bot for a personal consultation',
      categoryWardrobes: 'Wardrobes',
      categoryWardrobesSub: 'AIR LINE System',
      categoryDoors: 'Partitions & Doors',
      categoryDoorsSub: 'INTEGRA & OTIUM',
      categoryKitchens: 'Kitchens',
      categoryKitchensSub: 'RADIAL',
      categoryOther: 'Other / Custom Project',
      categoryOtherSub: 'Tell us more',
      back: 'Back',
      continue: 'Continue',
      submit: 'Connect on Telegram',
      submitting: 'Connecting...',
      namePh: 'Full name',
      phonePh: 'Phone (preferred contact)',
      emailPh: 'Email (optional)',
      nameRequired: 'Please tell us your name',
      phoneOrEmail: 'Phone or Email required',
      success: 'Thank you! Opening Telegram…',
      error: 'Something went wrong. Please try again.',
    },
    b2bDashboard: {
      title: 'Trade Dashboard',
      subtitle: 'Welcome back. Access your digital trade environment, manage API keys, and explore professional pricing.',
      eyebrow: 'Trade Portal · Approved partners only',
      apiTab: 'API Keys',
      projectsTab: 'Projects',
      ordersTab: 'Orders',
      techFilesTitle: 'Technical Files',
      openDownloadCenter: 'Open Download Center',
      noDownloads: 'No downloads available yet.',
      tradePricingTitle: 'Trade Pricing',
      tradePricingDesc: 'Your trade discount is automatically applied to all product prices across our digital environment.',
      browseProducts: 'Browse Products',
      pendingTitle: 'Application Under Review',
      pendingText: 'Your B2B application is being reviewed by our team. You will be notified once approved (usually within 1 business day).',
      accessDenied: 'Access Denied',
      accessDeniedText: 'You need an approved trade account to access this page.',
      learnMore: 'Learn About Trade Program',
      welcome: 'Welcome back',
      statusApproved: 'Verified Professional',
      statusPending: 'Pending Verification',
      apiTitle: 'API Integration',
      apiDesc: 'Generate secure read-only API tokens to integrate the complete FEDYK Furniture digital portfolio.',
      manageKeys: 'Manage API keys →',
    },
    b2bDownloads: {
      eyebrow: 'Trade Library · Approved partners only',
      title: 'Download Center',
      subtitle: 'Welcome. Browse every trade resource we publish — full catalogues, 3D models, technical packs and brochures.',
      description: 'Our complete annual portfolio — every collection, every system, every finish. Bound in a single, beautifully crafted PDF.',
      collections: 'Collection',
      allCollections: 'All collections',
      featuredCatalogue: 'Featured Catalogue',
      downloadCollectionBook: 'Download Collection Book',
      availableSoon: 'Download PDF — Available soon',
      categoryCatalogue: 'Catalogues',
      category3dModel: '3D Models',
      categoryTechPack: 'Technical Packs',
      categoryBrochure: 'Brochures',
      categorySpecification: 'Specifications',
      categoryOther: 'Other',
      noAssets: 'No additional trade assets uploaded yet. Check back soon.',
      backToDashboard: '← Back to Trade Program',
    },
    b2bApiKeys: {
      title: 'API Keys',
      subtitle: 'Issue read-only keys for your design tools — Revit, ArchiCAD, in-house dashboards. Each key inherits your trade access.',
      eyebrow: 'Trade Integration',
      backToDashboard: 'Back to dashboard',
      newApiKey: 'New API Key',
      saveYourKey: 'Save your key',
      keyGenerated: 'Key generated',
      keyGeneratedDesc: 'Create API key',
      showOnceWarning: 'Shown only once · store it now',
      copyToClipboard: 'Copy to clipboard',
      copied: 'Copied',
      savedWarning: 'I have saved it',
      doneBtn: 'Done',
      label: 'Label',
      scopes: 'Scopes',
      readCatalogDesc: 'Read products + trade pricing',
      readCollectionsDesc: 'Read collections',
      cancel: 'Cancel',
      generateKey: 'Generate Key',
      generating: 'Generating…',
      pendingTitle: 'Pending approval',
      pendingText: 'Your trade account is awaiting verification by our team. Once approved you\'ll be able to generate API keys here.',
      emptyState: 'No API keys generated yet.',
      firstKeyBtn: 'Generate your first key',
      tableKey: 'Key',
      tableScopes: 'Scopes',
      tableUsage: 'Usage',
      tableLastUsed: 'Last used',
      revoked: 'Revoked',
      revokeConfirm: 'Revoke key? Applications using it will lose access immediately.',
      documentationTitle: 'Quick start documentation',
      documentationDesc: 'Use the header X-API-Key or Authorization Bearer when calling your endpoints. Trade prices are returned automatically.',
    },
    orderTracker: {
      eyebrow: 'Production · Live status',
      title: 'Order Status',
      loading: 'Loading orders…',
      empty: 'You have no orders in production yet. Once a project enters our atelier, its live status will appear here and move through the stages below.',
      received: 'Order received',
      design: 'Engineering / Drawings',
      production: 'In production',
      qc_packing: 'QC & Packing',
      ready: 'Ready for installation',
    },
    projectSpec: {
      eyebrow: 'Specification · No online cart',
      title: 'Project Specification',
      new: 'New',
      placeholder: 'e.g. Villa in Belgium',
      loading: 'Loading projects…',
      empty: 'No projects yet. Create one to start compiling systems.',
      profile: 'Profile',
      glass: 'Glass',
      height: 'Height',
      qty: 'Qty',
      add: 'Add',
      placeholderAdd: 'Add a system (e.g. INTEGRA sliding partition)',
      clientProposal: 'Client Proposal',
      tradePricing: 'Trade Pricing',
      generating: 'Generating…',
      footerDesc: '“Client Proposal” shows retail figures only — safe to forward to the end client. “Trade Pricing” shows your net price with the professional discount applied.',
      modalEyebrow: 'Trade Program',
      modalTitle: 'Request Custom Pricing',
      modalDesc: 'Pricing is tailored to each project. Share the brief and Oksana will revert within 24h with a custom quote.',
      submittingAs: 'Submitting as',
      labelName: 'Name',
      labelEmail: 'Email',
      labelPhone: 'Phone',
      labelCompany: 'Company',
      projectName: 'Project Name *',
      projectPlaceholder: 'e.g. Villa Brussels · Kitchen renovation',
      productsInterest: 'Products / Items of Interest *',
      productsPlaceholder: 'AIR LINE wardrobe system, INTEGRA hidden-mount doors, RADIAL kitchen…',
      quantity: 'Quantity *',
      quantityPlaceholder: '3 wardrobes, 12 doors…',
      deadline: 'Target Deadline',
      deadlinePlaceholder: 'Q3 2026 / specific date',
      clientCompany: 'Client Company',
      clientCompanyPlaceholder: 'End-client / project owner',
      clientLocation: 'Client City / Country',
      clientLocationPlaceholder: 'Brussels, Belgium',
      budgetRange: 'Budget Range',
      budgetPlaceholder: '€50–80k / approximate',
      notes: 'Additional Notes',
      notesPlaceholder: 'Materials, finishes, installation context, special requests…',
      requiredHint: '* Required. Pricing is reviewed manually within 24 hours.',
      sendRequest: 'Send Request',
      sending: 'Sending…',
      successTitle: 'Request received',
      successDesc: 'We will contact you within one business day. Thank you for choosing FEDYK.',
      close: 'Close',
      selectProject: 'Select or create a project to compile its specification.',
    },
    account: {
      eyebrow: 'Cabinet',
      title: 'My Account',
      firstName: 'First Name',
      lastName: 'Last Name',
      emailAddress: 'Email Address',
      emailHint: 'To change your email, please contact atelier support.',
      phone: 'Phone Number',
      tradeDetails: 'Trade Partner Details',
      companyName: 'Company Name',
      vatNumber: 'VAT Number',
      streetNumber: 'Street & Number',
      officeSuite: 'Office / Suite',
      city: 'City',
      postalCode: 'Postal Code',
      country: 'Country',
      profession: 'Professional Role',
      saveChanges: 'Save Changes',
      saving: 'Saving Changes...',
      dangerZone: 'Danger Zone',
      dangerDesc: 'Once you request account deletion, we will send a confirmation link to your email. Clicking it will permanently purge all your data.',
      deleteBtn: 'Delete My Account',
      deleting: 'Processing...',
      deleteConfirm: 'Are you absolutely sure you want to request account deletion?',
      deleteSuccess: 'Verification link sent. Please check your email.',
    },
    product: {
      b2bTitle: 'B2B Trade Assets & Tools',
      b2bSub: 'Exclusive secure assets configured for verified design professionals.',
      noPdf: 'No PDF Document',
      no3d: 'No 3D Model File',
      addToSpec: 'Add to Project Spec',
      generatePdf: 'Generate PDF Specification',
      constructionMaterials: 'Construction & Materials',
      engineeringDetail: 'Engineering & Detail',
      matrixTitle: 'Bespoke Production Matrix',
      matrixSub: 'This system is modular and can be custom ordered in the alternative materials and textures curated below.',
      altMaterials: 'Alternative Available Materials:',
      altFinishes: 'Alternative Available Finishes / Textures:',
      customSizesTitle: 'Bespoke Size Upon Request',
      customSizesDesc: 'Available in custom configurations and floor-to-ceiling sheets up to 300cm. Contact our concierge or use the lead forms to submit your architectural plans for tailored project calculation.'
    },
  },
  nl: {
    nav: {
      home: 'Home',
      products: 'Producten',
      about: 'Over ons',
      b2c: 'Shop',
      b2b: 'Handel',
      projects: 'Projecten',
      blog: 'Blog',
      contact: 'Contact',
    },
    categories: {
      kitchens: 'Keukens',
      wardrobes: 'Kasten / Garderobes',
      doors: 'Deuren',
      wall_panels: 'Wandpanelen',
      soft_furniture: 'Zachte Meubels',
      ready_solutions: 'Kant-en-klare Oplossingen',
      custom_furniture: 'Maatwerk Meubels',
    },
    doorSubcategories: {
      invisible_doors: 'Onzichtbare Deuren',
      sliding_partitions: 'Schuifwanden',
      pivot_doors: 'Pivotdeuren',
    },
    common: {
      viewAll: 'Bekijk Alles',
      learnMore: 'Meer Info',
      requestQuote: 'Offerte Aanvragen',
      addToWishlist: 'Toevoegen aan Verlanglijst',
      removeFromWishlist: 'Verwijderen van Verlanglijst',
      addToQuote: 'Toevoegen aan Offerte',
      viewDetails: 'Bekijk Details',
      backTo: 'Terug naar',
      search: 'Zoek producten...',
      filter: 'Filteren',
      sort: 'Sorteren',
      price: 'Prijs',
      material: 'Materiaal',
      finish: 'Finish',
      category: 'Categorie',
      subcategory: 'Subcategorie',
      loading: 'Laden...',
      noResults: 'Geen resultaten gevonden',
      subscribe: 'Abonneren',
      send: 'Verzenden',
      submit: 'Versturen',
      required: 'Verplicht',
      optional: 'Optioneel',
      uploadPhoto: 'Foto Uploaden',
      budget: 'Budget',
      buildingType: 'Type Gebouw',
      newBuild: 'Nieuwbouw',
      under10Years: 'Onder 10 jaar',
      over10Years: 'Ouder dan 10 jaar',
      wishesComments: 'Wensen en Opmerkingen',
      featured: 'Uitgelicht',
      name: 'Naam',
      sortBy: 'Sorteer op',
      accept: 'Accepteren',
      cancel: 'Annuleren',
      ok: 'OK',
      backToProjects: 'Terug naar Projecten',
      exploreProducts: 'Producten Ontdekken',
      ourCollections: 'Onze Collecties',
      getInTouch: 'Neem contact op',
      clearFilters: 'Alle filters wissen',
      specifications: 'Specificaties',
      dimensions: 'Afmetingen',
      width: 'Breedte',
      depth: 'Diepte',
      height: 'Hoogte',
      weight: 'Gewicht',
    },
    hero: {
      title: 'ONE SPACE CONCEPT',
      subtitle: 'Een alomvattende benadering van interieurontwerp, waarbij esthetiek, comfort og geavanceerde functionaliteit naadloos zijn geïntegreerd.',
      cta: 'Ontdek het Concept',
    },
    about: {
      title: 'Over FEDYK Furniture',
      subtitle: 'Waar architectuur interieurdesign ontmoet',
      description: 'FEDYK Furniture vertegenwoordigt het toppunt van Europees vakmanschap.',
    },
    b2b: {
      title: 'Handelsprogramma',
      subtitle: 'Exclusieve voordelen for design professionals',
      architects: 'Architecten',
      designers: 'Interieur Ontwerpers',
      developers: 'Ontwikkelaars',
      dealers: 'Dealers',
      register: 'Registreren voor Handel',
      login: 'Handel Login',
      downloadCenter: 'Download Center',
      tradePricing: 'Handelsprijzen Matrix',
      projectSupport: 'Project Ondersteuning',
      architectsDesc: 'Gelicentieerde architectenpraktijken',
      designersDesc: 'Professionele interieurontwerpstudio\'s',
      developersDesc: 'Vastgoedontwikkelingsbedrijven',
      dealersDesc: 'Erkende retailpartners',
      eligibilityTitle: 'Wie kan zich aanmelden?',
      eligibilityEyebrow: 'Toegankelijkheid',
      readyTitle: 'Klaar om te beginnen?',
      readySub: 'Meld u vandaag nog aan voor ons handelsprogramma og ontgrendel exclusieve voordelen voor uw projecten.',
      readyBtn: 'Nu aanmelden',
      catalogEyebrow: 'Handelsbronnen',
      catalogDescFallback: 'Onze complete jaarlijkse portfolio — elke collectie, elk systeem, elke afwerking. Gebundeld in één prachtig vormgegeven PDF.',
      catalogBullet1: 'Volledige catalogus · 180+ pagina\'s',
      catalogBullet2: 'Technische tekeningen & materiaalbibliotheek',
      catalogBullet3: 'Gereserveerd voor goedgekeurde handelsaccounts',
      advantage_1_desc: 'CAD-bestanden, BIM-modellen, 3D-assets en technische specificaties.',
      advantage_2_desc: 'Prijzen zijn op maat per project. Stuur uw briefing — Oksana antwoordt binnen 24 uur.',
      advantage_3_desc: 'Directe lijn met onze conciërge. Vragen over materialen, levertijden, specs.',
      advantage_4_title: 'Project Samenwerking',
      advantage_4_desc: 'Ontwerp samen met onze studio maatwerk meubels. Stuur een projectbriefing.',
      cta_open_library: 'Open Bibliotheek →',
      cta_signin_required: 'Inloggen vereist',
      cta_request_quote: 'Offerte Aanvragen →',
      cta_talk_concierge: 'Spreek met Conciërge →',
      cta_submit_brief: 'Briefing Versturen →',
      cta: 'Meld u aan voor het handelsprogramma / Neem contact op',
    },
    contact: {
      title: 'Neem Contact Op',
      subtitle: 'Neem contact op met ons team',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      company: 'Bedrijf / Studio',
      subject: 'Onderwerp',
      message: 'Bericht',
      send: 'Verzend Bericht',
      offices: 'Onze Kantoren',
      primaryOffice: 'Hoofdkantoor',
      successMsg: 'Bericht verzonden!'
    },
    customFurniture: {
      title: 'Maatwerk Meubels Briefing',
      subtitle: 'Vertel ons over uw project',
      whatFurniture: 'Welk meubel of product wilt u?',
      roomDimensions: 'Afmetingen van de ruimte',
      attachPhotos: 'Voeg referentiefoto\'s toe',
      attachRoomPhotos: 'Voeg foto\'s van de ruimte toe',
      submitBrief: 'Briefing Versturen',
      successMessage: 'Uw briefing is ontvangen. We nemen spoedig contact met u op.',
    },
    cart: {
      title: 'Offerte Aanvraag',
      empty: 'Uw winkelwagen is leeg',
      checkout: 'Offerte Aanvragen',
      total: 'Totaal',
      yourDetails: 'Uw Gegevens',
      successMessage: 'Uw aanvraag is ontvangen. Een manager neemt contact met u op voor een factuur.',
    },
    newsletter: {
      title: 'Blijf op de Hoogte',
      subtitle: 'Abonneer om updates te ontvangen over nieuwe collecties.',
      placeholder: 'Voer uw e-mail in',
      success: 'Bedankt voor uw inschrijving!',
    },
    footer: {
      tagline: 'Architecturale elegantie for moderne interieurs',
      quickLinks: 'Snelle Links',
      support: 'Ondersteuning',
      legal: 'Juridisch',
      privacy: 'Privacybeleid',
      terms: 'Algemene Voorwaarden',
      cookies: 'Cookiebeleid',
      rights: 'Alle rechten voorbehouden.',
    },
    auth: {
      login: 'Inloggen',
      register: 'Registreren',
      logout: 'Uitloggen',
      email: 'E-mail',
      password: 'Wachtwoord',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      forgotPassword: 'Wachtwoord vergeten?',
      noAccount: 'Geen account?',
      hasAccount: 'Heeft u al een account?',
      b2bRegister: 'Registreren als Handelsprofessional',
      iAmProfessional: 'Ik ben een design professional (architect, ontwerper, aannemer, retailer)',
      companyName: 'Bedrijfsnaam',
      portfolioLink: 'Portfolio / Instagram-link',
      portfolioHint: 'Helpt ons uw studio sneller te verifiëren.',
      vatNumber: 'BTW-nummer (optioneel)',
      profession: 'Beroepsrol',
      architect: 'Architect',
      interiorDesigner: 'Interieurontwerper',
      contractor: 'Aannemer',
      retailer: 'Detailhandel',
      b2bSubmitted: 'Aanvraag verzonden!',
      pendingApprovalTitle: 'Aanvraag in Behandeling',
      pendingApprovalText: 'Uw B2B-aanvraag wordt beoordeeld.',
      accessDenied: 'Toegang Geweigerd',
      accessDeniedText: 'U heeft een goedgekeurd handelsaccount nodig.',
      loginSubtitle: 'Voer uw gegevens in',
      registerSubtitle: 'Maak uw account aan',
      signingIn: 'Bezig met inloggen...',
      registering: 'Account aanmaken...',
      areYouPro: 'Bent u een ontwerpprofessional?',
      professionalAddress: 'Professioneel adres',
      country: 'Land',
      city: 'Stad',
      postalCode: 'Postcode',
      streetAddress: 'Straat en huisnummer',
      welcomeBack: 'Welkom terug!',
      loginFailed: 'Inloggen mislukt',
      registrationSuccess: 'Registratie gelukt!',
      registrationFailed: 'Registratie mislukt',
    },
    chat: {
      title: 'FEDYK Furniture Support',
      subtitle: 'Stel uw vraag',
      placeholder: 'Typ een bericht...',
      send: 'Verzenden',
      connectWhatsApp: 'Doorgaan op WhatsApp',
      connectTelegram: 'Doorgaan op Telegram',
      requestHuman: 'Spreek met een persoon',
      humanConnecting: 'We verbinden u...',
      humanRequested: 'Een manager komt er zo aan...',
      greeting: 'Hallo! Hoe kan ik u vandaag helpen?',
      nameAsk: 'Wat is uw naam?',
      namePlaceholder: 'Uw naam',
      contactPlaceholder: 'Telefoon of e-mail (optioneel)',
      start: 'Start Chat',
      call: 'Bel ons',
      whatsapp: 'WhatsApp',
      proactive: 'Op zoek naar inspiratie? Onze architect kan een concept voor uw ruimte voorbereiden.'
    },
    lookbook: {
      lookbook: 'Lookbook',
      description: 'Een geselecteerde collectie maatwerkstukken.',
      requestConcept: 'Concept Aanvragen',
      consultArchitect: 'Architect Raadplegen',
      inConcept: 'In conceptaanvraag',
      eyebrow: 'Collecties',
      empty: 'Geen resultaten gevonden.',
      reset: 'Reset Filters',
      wishlistTitle: 'Verlanglijst',
      wishlistEyebrow: 'Bewaarde items'
    },
    leadCapture: {
      step1Title: 'Wat interesseert u?',
      step1Sub: 'Kies een collectie en we verbinden u met onze architect',
      step2Title: 'Uw contactgegevens',
      step2Sub: 'We sturen u door naar onze privé Telegram-bot',
      categoryWardrobes: 'Garderobekasten',
      categoryWardrobesSub: 'AIR LINE Systeem',
      categoryDoors: 'Deuren & Wanden',
      categoryDoorsSub: 'INTEGRA & OTIUM',
      categoryKitchens: 'Keukens',
      categoryKitchensSub: 'RADIAL',
      categoryOther: 'Anders / Maatwerk',
      categoryOtherSub: 'Vertel ons meer',
      back: 'Terug',
      continue: 'Doorgaan',
      submit: 'Verbinden via Telegram',
      submitting: 'Verbinden...',
      namePh: 'Volledige naam',
      phonePh: 'Telefoon',
      emailPh: 'E-mail',
      nameRequired: 'Vul uw naam in',
      phoneOrEmail: 'Telefoon of e-mail is verplicht',
      success: 'Bedankt! Telegram openen…',
      error: 'Er is iets misgegaan. Probeer het opnieuw.',
    },
    b2bDashboard: {
      title: 'Partner Dashboard',
      subtitle: 'Welkom terug.',
      eyebrow: 'Trade Portaal',
      apiTab: 'API-sleutels',
      projectsTab: 'Projecten',
      ordersTab: 'Bestellingen',
      techFilesTitle: 'Technische Bestanden',
      openDownloadCenter: 'Open Download Center',
      noDownloads: 'Nog geen downloads beschikbaar.',
      tradePricingTitle: 'Handelsprijzen',
      tradePricingDesc: 'Uw handelskorting wordt toegepast.',
      browseProducts: 'Producten Bekijken',
      pendingTitle: 'Aanvraag in Behandeling',
      pendingText: 'Uw B2B-aanvraag wordt beoordeeld.',
      accessDenied: 'Toegang Geweigerd',
      accessDeniedText: 'U heeft een goedgekeurd handelsaccount nodig.',
      learnMore: 'Meer informatie',
      welcome: 'Welkom terug',
      statusApproved: 'Geverifieerde Professional',
      statusPending: 'In Afwachting van Verificatie',
      apiTitle: 'API-integratie',
      apiDesc: 'Genereer beveiligde read-only API-tokens om de volledige digitale portfolio van FEDYK Furniture te integreren.',
      manageKeys: 'API-sleutels beheren →',
    },
    b2bDownloads: {
      eyebrow: 'Handelsbibliotheek',
      title: 'Download Center',
      subtitle: 'Welkom.',
      description: 'Onze complete jaarlijkse portfolio.',
      collections: 'Collectie',
      allCollections: 'Alle collecties',
      featuredCatalogue: 'Uitgelichte Catalogus',
      downloadCollectionBook: 'Download Collectieboek',
      availableSoon: 'Binnenkort beschikbaar',
      categoryCatalogue: 'Catalogi',
      category3dModel: '3D Modellen',
      categoryTechPack: 'Technische Pakketten',
      categoryBrochure: 'Brochures',
      categorySpecification: 'Specificaties',
      categoryOther: 'Overig',
      noAssets: 'Nog geen aanvullende handelsbestanden.',
      backToDashboard: 'Terug',
    },
    b2bApiKeys: {
      title: 'API-sleutels',
      subtitle: 'Genereer sleutels voor uw ontwerptools.',
      eyebrow: 'Handelsintegratie',
      backToDashboard: 'Terug',
      newApiKey: 'Nieuwe API-sleutel',
      saveYourKey: 'Sleutel opslaan',
      keyGenerated: 'Key gegenereerd',
      keyGeneratedDesc: 'API-sleutel aanmaken',
      showOnceWarning: 'Slechts één keer getoond',
      copyToClipboard: 'Kopieer',
      copied: 'Gekopieerd',
      savedWarning: 'Ik heb de sleutel opgeslagen',
      doneBtn: 'Gereed',
      label: 'Label',
      scopes: 'Machtigingen',
      readCatalogDesc: 'Lees producten',
      readCollectionsDesc: 'Lees collecties',
      cancel: 'Annuleren',
      generateKey: 'Genereer',
      generating: 'Laden…',
      pendingTitle: 'In behandeling',
      pendingText: 'Wacht op goedkeuring',
      emptyState: 'Geen sleutels.',
      firstKeyBtn: 'Genereer',
      tableKey: 'Sleutel',
      tableScopes: 'Scopes',
      tableUsage: 'Gebruik',
      tableLastUsed: 'Laatst gebruikt',
      revoked: 'Ingetrokken',
      revokeConfirm: 'Sleutel intrekken?',
      documentationTitle: 'Documentatie',
      documentationDesc: 'Gebruik de header X-API-Key.',
    },
    orderTracker: {
      eyebrow: 'Productie',
      title: 'Bestelstatus',
      loading: 'Laden…',
      empty: 'Geen bestellingen.',
      received: 'Aanvraag ontvangen',
      design: 'Ontwerp & Tekening',
      production: 'In productie',
      qc_packing: 'Kwaliteitscontrole',
      ready: 'Gereed',
    },
    projectSpec: {
      eyebrow: 'Specificatie',
      title: 'Projectspecificatie',
      new: 'Nieuw',
      placeholder: 'ex. Vilă',
      loading: 'Laden…',
      empty: 'Geen projecten.',
      profile: 'Profiel',
      glass: 'Glas',
      height: 'Hoogte',
      qty: 'Aantal',
      add: 'Toevoegen',
      placeholderAdd: 'Systeem toevoegen',
      clientProposal: 'Klantenvoorstel',
      tradePricing: 'Handelsprijzen',
      generating: 'Laden…',
      footerDesc: 'Klantenvoorstel toont retailprijzen.',
      modalEyebrow: 'Trade Programma',
      modalTitle: 'Aanvraag maatwerk prijzen',
      modalDesc: 'Prijzen zijn per project.',
      submittingAs: 'Verzonden als',
      labelName: 'Naam',
      labelEmail: 'E-mail',
      labelPhone: 'Telefoon',
      labelCompany: 'Bedrijf',
      projectName: 'Projectnaam *',
      projectPlaceholder: 'bijv. Villa',
      productsInterest: 'Producten *',
      productsPlaceholder: 'Systemen…',
      quantity: 'Aantal *',
      quantityPlaceholder: 'Aantal…',
      deadline: 'Deadline',
      deadlinePlaceholder: 'Datum…',
      clientCompany: 'Bedrijf klant',
      clientCompanyPlaceholder: 'Klant…',
      clientLocation: 'Locatie',
      clientLocationPlaceholder: 'Stad…',
      budgetRange: 'Budget',
      budgetPlaceholder: 'Budget…',
      notes: 'Opmerkingen',
      notesPlaceholder: 'Details…',
      requiredHint: '* Verplicht.',
      sendRequest: 'Verzenden',
      sending: 'Verzenden…',
      successTitle: 'Ontvangen',
      successDesc: 'We nemen snel contact op.',
      close: 'Sluiten',
      selectProject: 'Selecteer of maak een project aan om de specificatie samen te stellen.',
    },
    account: {
      eyebrow: 'Kabinet',
      title: 'Mijn account',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      emailAddress: 'E-mailadres',
      emailHint: 'Neem contact op.',
      phone: 'Telefoonnummer',
      tradeDetails: 'Handelsgegevens',
      companyName: 'Bedrijfsnaam',
      vatNumber: 'BTW-nummer',
      streetNumber: 'Street & Number',
      officeSuite: 'Box',
      city: 'Stad',
      postalCode: 'Postcode',
      country: 'Land',
      profession: 'Rol',
      saveChanges: 'Opslaan',
      saving: 'Laden…',
      dangerZone: 'Gevarenzone',
      dangerDesc: 'Account verwijderen.',
      deleteBtn: 'Verwijder account',
      deleting: 'Laden…',
      deleteConfirm: 'Weet u het zeker?',
      deleteSuccess: 'Link verzonden.',
    },
    product: {
      b2bTitle: 'B2B-handelsactiva & -tools',
      b2bSub: 'Exclusieve beveiligde activa geconfigureerd voor geverifieerde ontwerpprofessionals.',
      noPdf: 'Geen PDF-document',
      no3d: 'Geen 3D-modelbestand',
      addToSpec: 'Toevoegen aan projectspecificatie',
      generatePdf: 'PDF-specificatie genereren',
      constructionMaterials: 'Constructie & Materialen',
      engineeringDetail: 'Engineering & Details',
      matrixTitle: 'Bespoke Production Matrix',
      matrixSub: 'Dit systeem is modulair en kan op maat worden besteld in de alternatieve materialen en texturen hieronder.',
      altMaterials: 'Alternatieve beschikbare materialen:',
      altFinishes: 'Alternatieve beschikbare afwerkingen / texturen:',
      customSizesTitle: 'Maatwerk afmetingen op aanvraag',
      customSizesDesc: 'Beschikbaar in klantspecifieke configuraties en kamerhoge panelen tot 300cm. Neem contact op met onze conciërge of gebruik de formulieren om uw bouwplannen in te dienen.'
    },
  },
  ro: {
    nav: {
      home: 'Acasă',
      products: 'Produse',
      about: 'Despre noi',
      b2c: 'Magazin',
      b2b: 'Profesional',
      projects: 'Proiecte',
      blog: 'Journal',
      contact: 'Contact',
    },
    categories: {
      kitchens: 'Bucătării',
      wardrobes: 'Garderobe',
      doors: 'Uși',
      wall_panels: 'Panouri de Perete',
      soft_furniture: 'Mobilier Tapițat',
      ready_solutions: 'Soluții Gata',
      custom_furniture: 'Mobilier la Comandă',
    },
    doorSubcategories: {
      invisible_doors: 'Uși filomuro',
      sliding_partitions: 'Pereți Glisanți',
      pivot_doors: 'Uși pivotante',
    },
    common: {
      viewAll: 'Vezi Tot',
      learnMore: 'Află Mai Mult',
      requestQuote: 'Solicită Ofertă',
      addToWishlist: 'Adaugă la Favorite',
      removeFromWishlist: 'Elimină din Favorite',
      addToQuote: 'Adaugă la Cerere',
      viewDetails: 'Vezi Detalii',
      backTo: 'Înapoi la',
      search: 'Caută produse...',
      filter: 'Filtrează',
      sort: 'Sortează',
      price: 'Preț',
      material: 'Material',
      finish: 'Finisaj',
      category: 'Categorie',
      subcategory: 'Subcategorie',
      loading: 'Se încarcă...',
      noResults: 'Niciun rezultat',
      subscribe: 'Abonare',
      send: 'Trimite',
      submit: 'Trimite',
      required: 'Obligatoriu',
      optional: 'Opțional',
      uploadPhoto: 'Încarcă Foto',
      budget: 'Buget',
      buildingType: 'Tip Clădire',
      newBuild: 'Construcție Nouă',
      under10Years: 'Sub 10 ani',
      over10Years: 'Peste 10 ani',
      wishesComments: 'Dorințe și Comentarii',
      featured: 'Recomandat',
      name: 'Nume',
      sortBy: 'Ordonează după',
      elegance: 'Eleganță',
      accept: 'Acceptă',
      cancel: 'Anulare',
      ok: 'OK',
      backToProjects: 'Înapoi la Proiecte',
      exploreProducts: 'Explorează Produse',
      ourCollections: 'Colecțiile Noastre',
      getInTouch: 'Contactați-ne',
      clearFilters: 'Șterge toate filtrele',
      specifications: 'Specificații',
      dimensions: 'Dimensiuni',
      width: 'Lățime',
      depth: 'Adâncime',
      height: 'Înălțime',
      weight: 'Greutate',
    },
    hero: {
      title: 'ONE SPACE CONCEPT',
      subtitle: 'O abordare cuprinzătoare a designului interior, în care estetica, confortul și funcționalitatea avansată sunt integrate perfect.',
      cta: 'Descoperă Conceptul',
    },
    about: {
      title: 'Despre FEDYK Furniture',
      subtitle: 'Unde arhitectura întâlnește designul interior',
      description: 'FEDYK Furniture reprezintă apogeul meșteșugului european.',
    },
    b2b: {
      title: 'Program Profesional',
      subtitle: 'Beneficii exclusive pentru profesioniștii în design',
      architects: 'Arhitecți',
      designers: 'Designeri de Interior',
      developers: 'Dezvoltatori',
      dealers: 'Dealers',
      register: 'Înregistrare Profesională',
      login: 'Autentificare Profesională',
      downloadCenter: 'Centru de Descărcare',
      tradePricing: 'Prețuri Profesionale',
      projectSupport: 'Suport Proiecte',
      architectsDesc: 'Birouri de arhitectură licențiate',
      designersDesc: 'Studiouri profesionale de design interior',
      developersDesc: 'Companii de dezvoltare imobiliară',
      dealersDesc: 'Parteneri de retail autorizați',
      eligibilityTitle: 'Cine poate aplica?',
      eligibilityEyebrow: 'Eligibilitate',
      readyTitle: 'Sunteți gata să începeți?',
      readySub: 'Aplicați astăzi pentru programul nostru comercial și deblocați avantaje exclusive pentru proiectele dvs.',
      readyBtn: 'Aplicați acum',
      catalogEyebrow: 'Resurse Comerciale',
      catalogDescFallback: 'Portofoliul nostru anual complet — fiecare colecție, sistem și finisaj. Într-un singur PDF.',
      catalogBullet1: 'Catalog complet · peste 180 de pagini',
      catalogBullet2: 'Desene tehnice și biblioteca de materiale',
      catalogBullet3: 'Rezervat conturilor comerciale aprobate',
      advantage_1_desc: 'Fișiere CAD, modele BIM, active 3D și specificații tehnice.',
      advantage_2_desc: 'Prețurile sunt personalizate per proiect. Trimiteți brief-ul — Oksana răspunde în 24 de ore.',
      advantage_3_desc: 'Linie directă către serviciul nostru de concierge. Întrebări despre materiale, termene de livrare, specificații.',
      advantage_4_title: 'Colaborare pe Proiecte',
      advantage_4_desc: 'Co-proiectați mobilier la comandă cu studioul nostru. Trimiteți un brief de proiect.',
      cta_open_library: 'Deschide Biblioteca →',
      cta_signin_required: 'Autentificare obligatorie',
      cta_request_quote: 'Solicită Ofertă →',
      cta_talk_concierge: 'Discută cu Concierge →',
      cta_submit_brief: 'Trimite Briefingul →',
      cta: 'Alăturați-vă programului comercial / Contactați-ne',
    },
    contact: {
      title: 'Contactează-ne',
      subtitle: 'Ia legătura cu echipa noastră',
      name: 'Nume',
      email: 'E-mail',
      phone: 'Telefon',
      company: 'Companie / Studio',
      subject: 'Subiect',
      message: 'Mesaj',
      send: 'Trimite Mesajul',
      offices: 'Birourile Noastre',
      primaryOffice: 'Biroul Principal',
      successMsg: 'Mesaj trimis!'
    },
    customFurniture: {
      title: 'Briefing Mobilier la Comandă',
      subtitle: 'Spune-ne despre proiectul tău',
      whatFurniture: 'Ce mobilier sau produs doriți?',
      roomDimensions: 'Dimensiunile camerei/spațiului',
      attachPhotos: 'Atașează fotografii de referință',
      attachRoomPhotos: 'Atașează fotografii ale camerei',
      submitBrief: 'Trimite Briefingul',
      successMessage: 'Briefingul dvs. a fost trimis. Vă vom contacta în curând.',
    },
    cart: {
      title: 'Cerere de Ofertă',
      empty: 'Coșul tău este gol',
      checkout: 'Solicită Ofertă',
      total: 'Total',
      yourDetails: 'Datele Tale',
      successMessage: 'Cererea dvs. a fost primită. Un manager vă va contacta pentru a emite factura.',
    },
    newsletter: {
      title: 'Fii la Curent',
      subtitle: 'Abonează-te pentru a primi noutăți despre colecțiile noi.',
      placeholder: 'Introduceți e-mail-ul',
      success: 'Mulțumim pentru abonare!',
    },
    footer: {
      tagline: 'Eleganță arhitecturală pentru interioare moderne',
      quickLinks: 'Link-uri Rapide',
      support: 'Suport',
      legal: 'Legal',
      privacy: 'Politica de Confidențialitate',
      terms: 'Termeni și Condiții',
      cookies: 'Politica de Cookie-uri',
      rights: 'Toate drepturile rezervate.',
    },
    auth: {
      login: 'Autentificare',
      register: 'Înregistrare',
      logout: 'Deconectare',
      email: 'E-mail',
      password: 'Parolă',
      firstName: 'Prenume',
      lastName: 'Nume',
      forgotPassword: 'Ai uitat parola?',
      noAccount: 'Nu ai cont?',
      hasAccount: 'Ai deja cont?',
      b2bRegister: 'Înregistrare ca Profesionist',
      iAmProfessional: 'Sunt un profesionist în design (architect, designer, antreprenor, retailer)',
      companyName: 'Numele Companiei',
      portfolioLink: 'Link portofoliu / Instagram',
      portfolioHint: 'Ne ajută să vă verificăm studioul mai rapid.',
      vatNumber: 'Cod TVA (opțional)',
      profession: 'Rol Profesional',
      architect: 'Architect',
      interiorDesigner: 'Designer de Interior',
      contractor: 'Antreprenor',
      retailer: 'Retailer',
      b2bSubmitted: 'Cerere trimisă!',
      pendingApprovalTitle: 'Cerere în Curs de Revizuire',
      pendingApprovalText: 'Cererea dvs. B2B este în curs de revizuire de către echipa noastră.',
      accessDenied: 'Acces Refuzat',
      accessDeniedText: 'Aveți nevoie de un cont profesional aprobat.',
      loginSubtitle: 'Introduceți datele',
      registerSubtitle: 'Creați-vă contul',
      signingIn: 'Se conectează...',
      registering: 'Se creează contul...',
      areYouPro: 'Sunteți un profesionist în design?',
      professionalAddress: 'Adresă profesională',
      country: 'Țară',
      city: 'Oraș',
      postalCode: 'Cod poștal',
      streetAddress: 'Adresă (stradă)',
      welcomeBack: 'Bine ați revenit!',
      loginFailed: 'Autentificare eșuată',
      registrationSuccess: 'Înregistrare reușită!',
      registrationFailed: 'Înregistrare eșuată',
    },
    chat: {
      title: 'Suport FEDYK Furniture',
      subtitle: 'Cum te putem ajuta?',
      placeholder: 'Scrie un mesaj...',
      send: 'Trimite',
      connectWhatsApp: 'Continuă pe WhatsApp',
      connectTelegram: 'Continuă pe Telegram',
      requestHuman: 'Vorbește cu o persoană',
      humanConnecting: 'Te conectăm...',
      humanRequested: 'Un manager se va alătura în curând...',
      greeting: 'Bună! Cum vă pot ajuta astăzi?',
      nameAsk: 'Cum vă numiți?',
      namePlaceholder: 'Numele dvs.',
      contactPlaceholder: 'Telefon sau email (opțional)',
      start: 'Start Chat',
      call: 'Sună-ne',
      whatsapp: 'WhatsApp',
      proactive: 'Căutați inspirație? Arhitectul nostru poate pregăti un concept pentru spațiul dvs.'
    },
    lookbook: {
      lookbook: 'Lookbook',
      description: 'O selecție curată de piese la comandă.',
      requestConcept: 'Solicită Concept',
      consultArchitect: 'Consultă un Arhitect',
      inConcept: 'În cererea de concept',
      eyebrow: 'Colecții',
      empty: 'Niciun rezultat găsit.',
      reset: 'Resetează Filtrele',
      wishlistTitle: 'Favorite',
      wishlistEyebrow: 'Articole salvate'
    },
    leadCapture: {
      step1Title: 'Ce vă interesează?',
      step1Sub: 'Alegeți o colecție și vă vom conecta cu arhitectul nostru',
      step2Title: 'Datele dvs. de contact',
      step2Sub: 'Vă vom redirecționa către botul nostru privat de Telegram pentru o consultație personală',
      categoryWardrobes: 'Garderobe',
      categoryWardrobesSub: 'Sistemul AIR LINE',
      categoryDoors: 'Uși & Compartimentări',
      categoryDoorsSub: 'INTEGRA & OTIUM',
      categoryKitchens: 'Bucătării',
      categoryKitchensSub: 'RADIAL',
      categoryOther: 'Alt proiect / Personalizat',
      categoryOtherSub: 'Spuneți-ne mai multe',
      back: 'Înapoi',
      continue: 'Continuă',
      submit: 'Conectare pe Telegram',
      submitting: 'Se conectează...',
      namePh: 'Nume complet',
      phonePh: 'Telefon',
      emailPh: 'E-mail',
      nameRequired: 'Vă rugăm să introduceți numele',
      phoneOrEmail: 'Numărul de telefon sau e-mailul este obligatoriu',
      success: 'Vă mulțumim! Se deschide Telegram…',
      error: 'Ceva nu a mers bine. Vă rugăm să încercați din nou.',
    },
    b2bDashboard: {
      title: 'Portal Parteneri',
      subtitle: 'Bine ați revenit. Accesați mediul dvs. profesional, gestionați cheile API și explorați specificațiile.',
      eyebrow: 'Portal Profesional · Exclusiv parteneri verificați',
      apiTab: 'Chei API',
      projectsTab: 'Specificații Proiect',
      ordersTab: 'Urmărire Comenzi',
      techFilesTitle: 'Librărie Tehnică',
      openDownloadCenter: 'Deschide Centrul de Descărcare',
      noDownloads: 'Niciun fișier disponibil momentan.',
      tradePricingTitle: 'Prețuri Profesionale',
      tradePricingDesc: 'Discountul dvs. comercial este aplicat automat pentru toate specificațiile de produse.',
      browseProducts: 'Răsfoiește Catalogul',
      pendingTitle: 'Cerere în Curs de Revizuire',
      pendingText: 'Cererea dvs. B2B este în curs de revizuire. Veți fi notificat prin e-mail.',
      accessDenied: 'Acces Refuzat',
      accessDeniedText: 'Aveți nevoie de un cont profesional aprobat pentru a accesa această pagină.',
      learnMore: 'Află mai multe despre program',
      welcome: 'Bine ați revenit',
      statusApproved: 'Profesionist Verificat',
      statusPending: 'În Așteptarea Verificării',
      apiTitle: 'Integrare API',
      apiDesc: 'Generați chei de securitate read-only pentru a integra portofoliul digital complet FEDYK Furniture.',
      manageKeys: 'Gestionare chei API →',
    },
    b2bDownloads: {
      eyebrow: 'Librărie Tehnică',
      title: 'Download Center',
      subtitle: 'Bine ați venit.',
      description: 'Portofoliul nostru anual complet.',
      collections: 'Colecție',
      allCollections: 'Toate colecțiile',
      featuredCatalogue: 'Catalog Recomandat',
      downloadCollectionBook: 'Descarcă Catalogul',
      availableSoon: 'Disponibil în curând',
      categoryCatalogue: 'Cataloage',
      category3dModel: 'Modele 3D',
      categoryTechPack: 'Pachete Tehnice',
      categoryBrochure: 'Broșuri',
      categorySpecification: 'Specificări',
      categoryOther: 'Altele',
      noAssets: 'Nu s-au încărcat încă fișiere tehnice suplimentare.',
      backToDashboard: 'Înapoi',
    },
    b2bApiKeys: {
      title: 'Chei API',
      subtitle: 'Generați chei pentru unelte de design.',
      eyebrow: 'Integrare Profesională',
      backToDashboard: 'Înapoi',
      newApiKey: 'Cheie API Nouă',
      saveYourKey: 'Salvați cheia',
      keyGenerated: 'Cheie generată',
      keyGeneratedDesc: 'Generare cheie API',
      showOnceWarning: 'Afișată o singură dată',
      copyToClipboard: 'Copiază',
      copied: 'Copiat',
      savedWarning: 'Am salvat cheia',
      doneBtn: 'Gata',
      label: 'Etichetă',
      scopes: 'Permisiuni',
      readCatalogDesc: 'Citiți produsele',
      readCollectionsDesc: 'Citiți colecțiile',
      cancel: 'Anulare',
      generateKey: 'Generează',
      generating: 'Se încarcă…',
      pendingTitle: 'În așteptare',
      pendingText: 'Așteaptă aprobare',
      emptyState: 'Nicio cheie.',
      firstKeyBtn: 'Generează',
      tableKey: 'Cheie',
      tableScopes: 'Permisiuni',
      tableUsage: 'Utilizare',
      tableLastUsed: 'Ultima utilizare',
      revoked: 'Anulat',
      revokeConfirm: 'Anulați cheia?',
      documentationTitle: 'Documentație',
      documentationDesc: 'Utilizați header-ul X-API-Key.',
    },
    orderTracker: {
      eyebrow: 'Production · Live status',
      title: 'Status Comandă',
      loading: 'Se încarcă…',
      empty: 'Nicio comandă.',
      received: 'Cerere primită',
      design: 'Proiectare & Desen',
      production: 'În producție',
      qc_packing: 'Control calitate',
      ready: 'Gata',
    },
    projectSpec: {
      eyebrow: 'Specificație',
      title: 'Specificație Proiect',
      new: 'Nou',
      placeholder: 'ex. Vilă',
      loading: 'Se încarcă…',
      empty: 'Niciun proiect creat încă.',
      profile: 'Profil',
      glass: 'Sticlă',
      height: 'Înălțime',
      qty: 'Cantitate',
      add: 'Adaugă',
      placeholderAdd: 'Adaugă sistem',
      clientProposal: 'Propunere Client',
      tradePricing: 'Prețuri Trade',
      generating: 'Se încarcă…',
      footerDesc: 'Propunerea pentru client prezintă prețurile de retail.',
      modalEyebrow: 'Program Trade',
      modalTitle: 'Solicitare prețuri personalizate',
      modalDesc: 'Prețurile sunt stabilite per proiect.',
      submittingAs: 'Trimis ca',
      labelName: 'Nume',
      labelEmail: 'Email',
      labelPhone: 'Telefon',
      labelCompany: 'Companie',
      projectName: 'Nume Proiect *',
      projectPlaceholder: 'ex. Vilă',
      productsInterest: 'Produse *',
      productsPlaceholder: 'Sisteme…',
      quantity: 'Cantitate *',
      quantityPlaceholder: 'Cantitate…',
      deadline: 'Termen limită',
      deadlinePlaceholder: 'Dată…',
      clientCompany: 'Companie Client',
      clientCompanyPlaceholder: 'Client…',
      clientLocation: 'Locație',
      clientLocationPlaceholder: 'Oraș…',
      budgetRange: 'Budget',
      budgetPlaceholder: 'Budget…',
      notes: 'Note suplimentare',
      notesPlaceholder: 'Detalii…',
      requiredHint: '* Obligatoriu.',
      sendRequest: 'Trimite',
      sending: 'Se trimite…',
      successTitle: 'Primit',
      successDesc: 'Vă vom contacta în curând.',
      close: 'Închide',
      selectProject: 'Selectați sau creați un proiect pentru a-i compila specificația.',
    },
    account: {
      eyebrow: 'Cabinet',
      title: 'Contul meu',
      firstName: 'Prenume',
      lastName: 'Nume',
      emailAddress: 'Adresă de email',
      emailHint: 'Contactați suportul.',
      phone: 'Număr de telefon',
      tradeDetails: 'Detalii Partener Comercial',
      companyName: 'Numele Companiei',
      vatNumber: 'Cod fiscal / CIF (TVA)',
      streetNumber: 'Stradă și Număr',
      officeSuite: 'Birou / Cameră',
      city: 'Oraș',
      postalCode: 'Cod Poștal',
      country: 'Țară',
      profession: 'Rol',
      saveChanges: 'Salvează',
      saving: 'Se încarcă…',
      dangerZone: 'Zonă periculoasă',
      dangerDesc: 'Ștergere cont.',
      deleteBtn: 'Șterge contul',
      deleting: 'Se încarcă…',
      deleteConfirm: 'Sunteți sigur?',
      deleteSuccess: 'Link trimis.',
    },
    product: {
      b2bTitle: 'Materiale și Instrumente B2B',
      b2bSub: 'Resurse securizate exclusive configurate pentru profesioniști în design verificați.',
      noPdf: 'Niciun document PDF',
      no3d: 'Niciun fișier model 3D',
      addToSpec: 'Adaugă la specificația proiectului',
      generatePdf: 'Generează specificații PDF',
      constructionMaterials: 'Construcție și materiale',
      engineeringDetail: 'Inginerie și detalii',
      matrixTitle: 'Bespoke Production Matrix',
      matrixSub: 'Acest sistem este modular și poate fi comandat la cerere în materialele și texturile alternative selectate mai jos.',
      altMaterials: 'Materiale alternative disponibile:',
      altFinishes: 'Finisaje / texturi alternative disponibile:',
      customSizesTitle: 'Dimensiuni personalizate la cerere',
      customSizesDesc: 'Disponibil în configurații personalizate și panouri până la tavan de până la 300 cm. Contactați serviciul de concierge sau trimiteți planurile arhitecturale.'
    },
  },
  ru: {
    nav: {
      home: 'Главная',
      products: 'Продукция',
      about: 'О нас',
      b2c: 'Магазин',
      b2b: 'Для бизнеса',
      projects: 'Проекты',
      blog: 'Блог',
      contact: 'Контакты',
    },
    categories: {
      kitchens: 'Кухни',
      wardrobes: 'Шкафы',
      doors: 'Двери',
      wall_panels: 'Стеновые панели',
      soft_furniture: 'Мягкая мебель',
      ready_solutions: 'Готовые решения',
      custom_furniture: 'Мебель на заказ',
    },
    doorSubcategories: {
      invisible_doors: 'Двери скрытого монтажа',
      sliding_partitions: 'Раздвижные перегородки',
      pivot_doors: 'Поворотные двери',
    },
    common: {
      viewAll: 'Смотреть все',
      learnMore: 'Подробнее',
      requestQuote: 'Запросить расчет',
      addToWishlist: 'В избранное',
      removeFromWishlist: 'Удалить из избранного',
      addToQuote: 'Добавить в спецификацию',
      viewDetails: 'Подробнее',
      backTo: 'Назад к',
      search: 'Поиск товаров...',
      filter: 'Фильтр',
      sort: 'Сортировка',
      price: 'Цена',
      material: 'Материал',
      finish: 'Отделка',
      category: 'Категория',
      subcategory: 'Подкатегория',
      loading: 'Загрузка...',
      noResults: 'Ничего не найдено',
      subscribe: 'Подписаться',
      send: 'Отправить',
      submit: 'Отправить',
      required: 'Обязательно',
      optional: 'Необязательно',
      uploadPhoto: 'Загрузить фото',
      budget: 'Бюджет',
      buildingType: 'Тип здания',
      newBuild: 'Новостройка',
      under10Years: 'До 10 лет',
      over10Years: 'Старше 10 лет',
      wishesComments: 'Пожелания и комментарии',
      featured: 'Рекомендуемое',
      name: 'Имя',
      sortBy: 'Сортировка по',
      elegance: 'Элегантность',
      accept: 'Принять',
      cancel: 'Отмена',
      ok: 'ОК',
      backToProjects: 'Назад к проектам',
      exploreProducts: 'Перейти в каталог',
      ourCollections: 'Наши коллекции',
      getInTouch: 'Связаться с нами',
      clearFilters: 'Сбросить все фильтры',
      specifications: 'Характеристики',
      dimensions: 'Размеры',
      width: 'Ширина',
      depth: 'Глубина',
      height: 'Высота',
      weight: 'Вес',
    },
    hero: {
      title: 'ONE SPACE CONCEPT',
      subtitle: 'Комплексный подход к дизайну интерьера, где эстетика, комфорт и продвинутая функциональность гармонично интегрированы.',
      cta: 'Откройте Концепцию',
    },
    about: {
      title: 'О FEDYK Furniture',
      subtitle: 'Где архитектура встречает дизайн интерьера',
      description: 'FEDYK Furniture представляет вершину европейского мастерства.',
    },
    b2b: {
      title: 'Программа для Бизнеса',
      subtitle: 'Эксклюзивные преимущества для профессионалов дизайна',
      architects: 'Architects',
      designers: 'Interior Designers',
      developers: 'Developers',
      dealers: 'Dealers',
      register: 'Регистрация для бизнеса',
      login: 'Вход для бизнеса',
      downloadCenter: 'Центр загрузок',
      tradePricing: 'Трейд-калькуляция',
      projectSupport: 'Поддержка проектов',
      architectsDesc: 'Лицензированные архитектурные бюро',
      designersDesc: 'Профессиональные студии дизайна интерьера',
      developersDesc: 'Строительные и девелоперские компании',
      dealersDesc: 'Авторизованные розничные партнеры',
      eligibilityTitle: 'Кто может стать партнером?',
      eligibilityEyebrow: 'Условия вступления',
      readyTitle: 'Готовы начать?',
      readySub: 'Подайте заявку на участие в программе сегодня и разблокируйте закрытые коммерческие привилегии.',
      readyBtn: 'Подать заявку сейчас',
      catalogEyebrow: 'Материалы бренда',
      catalogDescFallback: 'Наш полный ежегодный каталог — каждая коллекция, раздвижная система и тип отделки в едином PDF.',
      catalogBullet1: 'Полный каталог · более 180 страниц',
      catalogBullet2: 'Чертежи, узлы примыканий и библиотека материалов',
      catalogBullet3: 'Доступно только для проверенных партнеров',
      advantage_1_desc: 'CAD-файлы, BIM-модели, 3D-объекты и технические спецификации.',
      advantage_2_desc: 'Цены рассчитываются под проект. Отправьте бриф — Оксана ответит в течение 24 часов.',
      advantage_3_desc: 'Прямая связь с нашим консьержем. Вопросы по материалам, срокам и спецификациям.',
      advantage_4_title: 'Взаимодействие по проектам',
      advantage_4_desc: 'Совместное проектирование мебели с нашей студией. Отправьте технический бриф.',
      cta_open_library: 'Открыть библиотеку →',
      cta_signin_required: 'Требуется регистрация',
      cta_request_quote: 'Трейд-калькуляция →',
      cta_talk_concierge: 'Связаться с консьержем →',
      cta_submit_brief: 'Отправить бриф →',
      cta: 'Вступить в Trade-программу / Связаться с нами',
    },
    contact: {
      title: 'Свяжитесь с нами',
      subtitle: 'Свяжитесь с нашей командой',
      name: 'Имя',
      email: 'E-mail',
      phone: 'Телефон',
      company: 'Компания',
      subject: 'Тема',
      message: 'Сообщение',
      send: 'Отправить сообщение',
      offices: 'Наши представительства',
      primaryOffice: 'Главный Офис',
      successMsg: 'Сообщение отправлено!'
    },
    customFurniture: {
      title: 'Бриф на мебель на заказ',
      subtitle: 'Расскажите нам о вашем проекте',
      whatFurniture: 'Какую мебель или изделие вы хотите?',
      roomDimensions: 'Габаритные размеры помещения/места',
      attachPhotos: 'Прикрепить референс фото',
      attachRoomPhotos: 'Прикрепить фото помещения',
      submitBrief: 'Отправить бриф',
      successMessage: 'Ваш бриф отправлен. Мы свяжемся с вами в ближайшее время.',
    },
    cart: {
      title: 'Запрос спецификации',
      empty: 'Ваша спецификация пуста',
      checkout: 'Запросить расчет',
      total: 'Итого',
      yourDetails: 'Ваши данные',
      successMessage: 'Ваш запрос получен. Менеджер свяжется с вами для выставления счета.',
    },
    newsletter: {
      title: 'Будьте в курсе',
      subtitle: 'Подпишитесь, чтобы получать обновления о новых коллекциях.',
      placeholder: 'Введите ваш e-mail',
      success: 'Спасибо за подписку!',
    },
    footer: {
      tagline: 'Архитектурная элегантность для современных интерьеров',
      quickLinks: 'Быстрые ссылки',
      support: 'Поддержка',
      legal: 'Правовая информация',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      cookies: 'Политика cookies',
      rights: 'Все права защищены.',
    },
    auth: {
      login: 'Войти',
      register: 'Регистрация',
      logout: 'Выйти',
      email: 'E-mail',
      password: 'Пароль',
      firstName: 'Имя',
      lastName: 'Фамилия',
      forgotPassword: 'Забыли пароль?',
      noAccount: 'Нет аккаунта?',
      hasAccount: 'Уже есть аккаунт?',
      b2bRegister: 'Регистрация как профессионал',
      iAmProfessional: 'Я профессионал в дизайне (архитектор, дизайнер, подрядчик, ритейлер)',
      companyName: 'Компания',
      portfolioLink: 'Ссылка на портфолио / Instagram',
      portfolioHint: 'Поможет нам быстрее верифицировать вашу студию.',
      vatNumber: 'НДС номер (опционально)',
      profession: 'Профессиональная роль',
      architect: 'Архитектор',
      interiorDesigner: 'Дизайнер интерьера',
      contractor: 'Подрядчик',
      retailer: 'Ритейлер',
      b2bSubmitted: 'Заявка отправлена!',
      pendingApprovalTitle: 'Заявка на рассмотрении',
      pendingApprovalText: 'Ваша B2B-заявка рассматривается нашей командой. Вы получите уведомление об одобрении (обычно в течение 1 рабочего дня).',
      accessDenied: 'Доступ запрещён',
      accessDeniedText: 'Для доступа к этой странице необходим одобренный B2B-аккаунт.',
      loginSubtitle: 'Введите данные для входа в аккаунт',
      registerSubtitle: 'Создайте аккаунт, чтобы начать',
      signingIn: 'Вход...',
      registering: 'Создание аккаунта...',
      areYouPro: 'Вы дизайнер или архитектор?',
      professionalAddress: 'Профессиональный адрес',
      country: 'Страна',
      city: 'Город',
      postalCode: 'Почтовый индекс',
      streetAddress: 'Улица, дом',
      welcomeBack: 'С возвращением!',
      loginFailed: 'Ошибка входа',
      registrationSuccess: 'Регистрация успешна! Проверьте почту для подтверждения аккаунта.',
      registrationFailed: 'Ошибка регистрации',
    },
    chat: {
      title: 'Поддержка FEDYK Furniture',
      subtitle: 'Задайте вопрос',
      placeholder: 'Напишите сообщение...',
      send: 'Отправить',
      connectWhatsApp: 'Продолжить в WhatsApp',
      connectTelegram: 'Продолжить в Telegram',
      requestHuman: 'Связаться с человеком',
      humanConnecting: 'Соединяем вас...',
      humanRequested: 'Менеджер скоро подключится...',
      greeting: 'Здравствуйте! Чем могу помочь? Я могу ответить на вопросы о наших товарах, услугах и ценах.',
      nameAsk: 'Как вас зовут?',
      namePlaceholder: 'Ваше имя',
      contactPlaceholder: 'Телефон или Email (необязательно)',
      start: 'Начать чат',
      call: 'Позвонить нам',
      whatsapp: 'WhatsApp',
      proactive: 'Ищете вдохновение? Наш архитектор может разработать концепцию для вашего пространства.'
    },
    lookbook: {
      lookbook: 'Lookbook',
      description: 'Коллекция авторских предметов.',
      requestConcept: 'Запросить концепцию',
      consultArchitect: 'Консультация архитектора',
      inConcept: 'Запрос концепции',
      eyebrow: 'Collections',
      empty: 'Нет предметов по вашему фильтру.',
      reset: 'Сбросить фильтры',
      wishlistTitle: 'Избранное',
      wishlistEyebrow: 'Сохраненные товары'
    },
    leadCapture: {
      step1Title: 'Что вас интересует?',
      step1Sub: 'Выберите направление, и мы свяжем вас с архитектором',
      step2Title: 'Ваши контактные данные',
      step2Sub: 'Мы свяжемся с вами в Telegram для детального обсуждения',
      categoryWardrobes: 'Гардеробы',
      categoryWardrobesSub: 'Система AIR LINE',
      categoryDoors: 'Перегородки и Двери',
      categoryDoorsSub: 'INTEGRA & OTIUM',
      categoryKitchens: 'Кухни',
      categoryKitchensSub: 'RADIAL',
      categoryOther: 'Другое / Индивидуальный проект',
      categoryOtherSub: 'Расскажите нам больше',
      back: 'Назад',
      continue: 'Продолжить',
      submit: 'Связаться в Telegram',
      submitting: 'Соединение...',
      namePh: 'Ваше имя',
      phonePh: 'Телефон (активный контакт)',
      emailPh: 'Email (необязательно)',
      nameRequired: 'Пожалуйста, введите ваше имя',
      phoneOrEmail: 'Пожалуйста, укажите телефон или Email',
      success: 'Спасибо! Открываем Telegram…',
      error: 'Что-то пошло не так. Пожалуйста, попробуйте еще раз.',
    },
    b2bDashboard: {
      title: 'Архитектурный хаб',
      subtitle: 'Добро пожаловать в профессиональный кабинет FEDYK.',
      eyebrow: 'B2B кабинет партнеров',
      apiTab: 'Ключи API',
      projectsTab: 'Проекты',
      ordersTab: 'Заказы в производстве',
      techFilesTitle: 'Технические файлы',
      openDownloadCenter: 'Открыть Центр загрузок',
      noDownloads: 'Файлы пока не добавлены.',
      tradePricingTitle: 'Трейд-калькуляция',
      tradePricingDesc: 'Ваша профессиональная скидка автоматически применяется ко всем ценам в каталоге.',
      browseProducts: 'Перейти в каталог',
      pendingTitle: 'На рассмотрении',
      pendingText: 'Ваша учетная запись ожидает проверки администратором.',
      accessDenied: 'Доступ ограничен',
      accessDeniedText: 'Пожалуйста, войдите в систему под подтвержденной учетной записью партнера.',
      learnMore: 'Подробнее о программе',
      welcome: 'С возвращением',
      statusApproved: 'Verified Professional',
      statusPermanent: 'Pending Verification',
      apiTitle: 'Интеграция API',
      apiDesc: 'Создавайте безопасные токены доступа (read-only) для интеграции полного цифрового портфолио FEDYK Furniture.',
      manageKeys: 'Управление ключами API →',
    },
    b2bDownloads: {
      eyebrow: 'Библиотека B2B',
      title: 'Центр загрузок',
      subtitle: 'Добро пожаловать в архив технических файлов.',
      description: 'Полный ежегодный каталог FEDYK Furniture со всеми системами и типами отделки.',
      collections: 'Коллекция',
      allCollections: 'Все коллекции',
      featuredCatalogue: 'Основной каталог',
      downloadCollectionBook: 'Скачать каталог',
      availableSoon: 'Файл скоро будет доступен',
      categoryCatalogue: 'Каталоги',
      category3dModel: '3D-Модели',
      categoryTechPack: 'Чертежи и узлы',
      categoryBrochure: 'Брошюры',
      categorySpecification: 'Спецификации',
      categoryOther: 'Другое',
      noAssets: 'Технические файлы пока не загружены. Мы добавим их в ближайшее время.',
      backToDashboard: '← Назад в рабочий кабинет',
    },
    b2bApiKeys: {
      title: 'Ключи API',
      subtitle: 'Создавайте токены доступа для интеграции нашей библиотеки в ваши рендер-движки, Revit и ArchiCAD.',
      eyebrow: 'B2B Интеграция',
      backToDashboard: 'Назад в кабинет',
      newApiKey: 'Новый API ключ',
      saveYourKey: 'Сохраните ваш ключ',
      keyGenerated: 'Ключ успешно создан',
      keyGeneratedDesc: 'Генерация токена доступа',
      showOnceWarning: 'Показывается только один раз — запишите его',
      copyToClipboard: 'Копировать',
      copied: 'Скопировано',
      savedWarning: 'Я сохранил ключ',
      doneBtn: 'Готово',
      label: 'Название',
      scopes: 'Уровни доступа',
      readCatalogDesc: 'Чтение каталога + трейд-цена',
      readCollectionsDesc: 'Чтение коллекций',
      cancel: 'Отмена',
      generateKey: 'Создать',
      generating: 'Создание…',
      pendingTitle: 'На рассмотрении',
      pendingText: 'Ваш аккаунт ожидает подтверждения для выпуска ключей API.',
      emptyState: 'У вас пока нет активных API ключей.',
      firstKeyBtn: 'Создать первый ключ',
      tableKey: 'Ключ',
      tableScopes: 'Доступы',
      tableUsage: 'Использование',
      tableLastUsed: 'Активность',
      revoked: 'Отозван',
      revokeConfirm: 'Отозвать этот ключ? Все сторонние плагины и софт, использующие его, моментально потеряют доступ.',
      documentationTitle: 'Инструкция по интеграции',
      documentationDesc: 'Передавайте ключ в заголовке X-API-Key или Bearer токена. Цены со скидкой будут возвращаться автоматически.',
    },
    orderTracker: {
      eyebrow: 'Ателье · Статус производства',
      title: 'Live-статус производства',
      loading: 'Загрузка...',
      empty: 'У вас пока нет активных заказов на производстве. Как только чертежи проекта поступят в работу, статус появится здесь.',
      received: 'Заказ принят в обработку',
      design: 'Проектирование и КД',
      production: 'В производстве на фабрике',
      qc_packing: 'Приемка ОТК и Упаковка',
      ready: 'Готов к монтажу',
    },
    projectSpec: {
      eyebrow: 'Спецификация · Без онлайн-корзины',
      title: 'Архитектурная ведомость объекта',
      new: 'Новый проект',
      placeholder: 'напр. Вилла в Брюсселе',
      loading: 'Загрузка проектов...',
      empty: 'Проекты пока не созданы. Добавьте первый проект, чтобы начать собирать изделия.',
      profile: 'Профиль',
      glass: 'Стекло',
      height: 'Высота',
      qty: 'Кол-во',
      add: 'Добавить',
      placeholderAdd: 'Добавить изделие (напр. перегородку INTEGRA)',
      clientProposal: 'КП для клиента',
      tradePricing: 'Трейд-калькуляция',
      generating: 'Генерация...',
      footerDesc: '«КП для клиента» содержит только розничные цены — его безопасно пересылать конечному заказчику. «Трейд-калькуляция» содержит расчет с учетом вашей профессиональной скидки.',
      modalEyebrow: 'B2B-Программа',
      modalTitle: 'Запрос профессиональной спецификации',
      modalDesc: 'Мы рассчитываем цены индивидуально под каждый проект. Опишите задачу, и Оксана подготовит расчет в течение 24 часов.',
      submittingAs: 'Отправка от имени',
      labelName: 'Имя',
      labelEmail: 'Email',
      labelPhone: 'Телефон',
      labelCompany: 'Company',
      projectName: 'Название проекта *',
      projectPlaceholder: 'напр. Квартира Брюссель · Раздвижные двери',
      productsInterest: 'Продукты / Изделия *',
      productsPlaceholder: 'Шкафы AIR LINE, скрытые двери INTEGRA, кухни...',
      quantity: 'Количество *',
      quantityPlaceholder: '3 шкафа, 12 дверей...',
      deadline: 'Сроки сдачи проекта',
      deadlinePlaceholder: 'Q3 2026 / точная дата',
      clientCompany: 'Компания клиента',
      clientCompanyPlaceholder: 'Конечный заказчик / дизайн-студия',
      clientLocation: 'Город / Страна',
      clientLocationPlaceholder: 'Брюссель, Бельгия',
      budgetRange: 'Ориентировочный бюджет',
      budgetPlaceholder: '€50–80k / примерно',
      notes: 'Дополнительные примечания',
      notesPlaceholder: 'Materials, finishes, installation context, special requests…',
      requiredHint: '* Обязательные поля. Запросы обрабатываются вручную фабрикой FEDYK.',
      sendRequest: 'Send Request',
      sending: 'Отправка...',
      successTitle: 'Запрос принят в работу',
      successDesc: 'Мы свяжемся с вами в течение одного рабочего дня для согласования деталей. Спасибо за выбор FEDYK Furniture.',
      close: 'Закрыть',
      selectProject: 'Выберите или создайте проект, чтобы составить его спецификацию.',
    },
    account: {
      eyebrow: 'Кабинет',
      title: 'Мой профиль',
      firstName: 'Имя',
      lastName: 'Фамилия',
      emailAddress: 'Email адрес',
      emailHint: 'Для смены почты, пожалуйста, свяжитесь с поддержкой фабрики.',
      phone: 'Номер телефона',
      tradeDetails: 'Данные партнера',
      companyName: 'Название компании',
      vatNumber: 'НДС номер (VAT)',
      streetNumber: 'Улица и дом',
      officeSuite: 'Офис / апартаменты',
      city: 'Город',
      postalCode: 'Индекс',
      country: 'Страна',
      profession: 'Профессиональная роль',
      saveChanges: 'Сохранить изменения',
      saving: 'Сохранение...',
      dangerZone: 'Удаление профиля',
      dangerDesc: 'При запросе на удаление учетной записи мы вышлем ссылку подтверждения на ваш email. Подтверждение необратимо очистит все ваши данные.',
      deleteBtn: 'Запросить удаление аккаунта',
      deleting: 'Обработка...',
      deleteConfirm: 'Вы действительно хотите запросить полное удаление учетной записи и всех накопленных проектов?',
      deleteSuccess: 'Ссылка для подтверждения отправлена на вашу почту. Проверьте ваш входящий ящик.',
    },
    product: {
      b2bTitle: 'B2B материалы и инструменты',
      b2bSub: 'Эксклюзивные защищенные файлы для верифицированных профессионалов дизайна.',
      noPdf: 'Нет PDF документа',
      no3d: 'Нет 3D модели',
      addToSpec: 'Добавить в спецификацию',
      generatePdf: 'Создать PDF спецификацию',
      constructionMaterials: 'Конструкция и материалы',
      engineeringDetail: 'Чертежи и детализация',
      matrixTitle: 'Матрица индивидуального производства',
      matrixSub: 'Данная система является модульной и может быть заказана в альтернативных материалах и текстурах, представленных ниже.',
      altMaterials: 'Доступные материалы основы:',
      altFinishes: 'Доступные варианты отделки:',
      customSizesTitle: 'Индивидуальные размеры под заказ',
      customSizesDesc: 'Доступно в кастомных конфигурациях и цельных полотнах под потолок высотой до 300 см. Свяжитесь с консьержем или заполните форму, чтобы отправить архитектурный план для точного расчета.'
    },
  },
};

// Deep merge overrides into active state dictionary with strict case insensitivity
const applyOverrides = (baseTranslations, overrides) => {
  const merged = JSON.parse(JSON.stringify(baseTranslations));
  if (!overrides) return merged;

  Object.entries(overrides).forEach(([path, langs]) => {
    const parts = path.split('.');
    if (parts.length !== 2) return;
    const [rawSection, rawKey] = parts;

    Object.entries(langs).forEach(([lang, val]) => {
      if (val && typeof val === 'string' && merged[lang]) {
        // Находим раздел (например, doorSubcategories) без учета регистра букв
        const sectionTarget = Object.keys(merged[lang]).find(
          s => s.toLowerCase() === rawSection.toLowerCase()
        );
        
        if (sectionTarget) {
          // Находим ключ внутри раздела (например, swing_doors) без учета регистра
          const keyTarget = Object.keys(merged[lang][sectionTarget]).find(
            k => k.toLowerCase() === rawKey.toLowerCase()
          );
          
          if (keyTarget) {
            merged[lang][sectionTarget][keyTarget] = val;
          } else {
            // Если ключ абсолютно новый
            merged[lang][sectionTarget][rawKey] = val;
          }
        }
      }
    });
  });

  return merged;
};

// Retrieve cached overrides from sessionStorage for instant zero-flash render
const getCachedOverrides = () => {
  try {
    const cached = sessionStorage.getItem('fedyk_translation_overrides');
    return cached ? JSON.parse(cached) : null;
  } catch (e) {
    return null;
  }
};

const saveCachedOverrides = (overrides) => {
  try {
    sessionStorage.setItem('fedyk_translation_overrides', JSON.stringify(overrides));
  } catch (e) {}
};

// Initialize active translations instantly with cached overrides to prevent layout shifts
let activeTranslations = applyOverrides(translations, getCachedOverrides());
const listeners = new Set();

const updateActiveTranslations = (overrides) => {
  activeTranslations = applyOverrides(translations, overrides);
  listeners.forEach(listener => listener(activeTranslations));
};

// Trigger fetch of active overrides from public Copy endpoint with aggressive cache-busting
const fetchOverrides = async () => {
  try {
    const res = await fetch(`${API}/api/public/copy?t=${Date.now()}`);
    if (res.ok) {
      const data = await res.json();
      const overrides = data.overrides || {};
      saveCachedOverrides(overrides);
      updateActiveTranslations(overrides);
    }
  } catch (err) {
    console.error("Failed to load translation overrides:", err);
  }
};

// Initial fetch trigger on window context load
if (typeof window !== 'undefined') {
  fetchOverrides();
  window.addEventListener('site-copy-updated', fetchOverrides);
}

// React custom translation hook registers listeners for real-time reactive updates
export const useTranslation = (lang = 'en') => {
  const [currentTrans, setCurrentTrans] = useState(activeTranslations);

  useEffect(() => {
    const handleUpdate = (next) => setCurrentTrans(next);
    listeners.add(handleUpdate);
    return () => {
      listeners.delete(handleUpdate); // Безопасное удаление слушателя для исключения утечек и рассинхрона
    };
  }, []);

  const language = lang || 'en';
  return {
    t: currentTrans[language] || currentTrans['en'] || translations['en']
  };
};
